export const defaultUrgencyBadges = [
    {
        style: { backgroundColor: 'var(--primary, "#309AB5")', color: 'var(--primary-foreground, "#FFFFFF")' },
        label: "Alert badge - default"
    },
    {
        style: { backgroundColor: 'var(--info, "#0891B2")', color: 'var(--info-foreground, "#ECFEFF")' },
        label: "Alert badge - informative"
    },
    {
        style: { backgroundColor: 'var(--success, "#15803D")', color: 'var(--success-foreground, "#DCFCE7")' },
        label: "Alert badge - success"
    },
    {
        style: { backgroundColor: 'var(--warning, "#A16207")', color: 'var(--warning-foreground, "#FEF9C3")' },
        label: "Alert badge - warning"
    },
    {
        style: { backgroundColor: 'var(--destructive, "#ff0")', color: 'var(--destructive-foreground, "#FEF2F2")' },
        label: "Alert badge - error"
    }
];

export const defaultAlerts = [
    {
        variant: 'info',
        style: { color: 'var(--info, "#309AB5")', boxShadow: 'var(--shadow-sm)'},
        title: "Informative",
        description: "This is an alert description."
    },
    {
        variant: 'success',
        style: { color: 'var(--success, "#0891B2")', boxShadow: 'var(--shadow-sm)'},
        title: "Success",
        description: "This is an alert description."
    },
    {
        variant: 'warning',
        style: { color: 'var(--warning, "#15803D")', boxShadow: 'var(--shadow-sm)'},
        title: "Warning",
        description: "This is an alert description."
    },
    {
        variant: 'error',
        style: { color: 'var(--destructive, "#A16207")', boxShadow: 'var(--shadow-sm)'},
        title: "Error",
        description: "This is an alert description."
    }
];


// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/utils/urgencyData.js